if (!customElements.get('scroll-observer')) {
  customElements.define(
    'scroll-observer',
    class ScrollObserver extends HTMLElement {
      constructor() {
        super();
        this.observer = null;
        this.threshold = this.getAttribute('threshold') || 0.3;
        this.useOnce = this.hasAttribute('data-use-once');
      }

      connectedCallback() {
        const options = {
          root: null,
          rootMargin: '0px',
          threshold: this.threshold,
        };

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add('visible');
              if (this.useOnce) this.observer.unobserve(this);
            } else {
              this.classList.remove('visible');
            }
          });
        }, options);

        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
      }
    }
  );
}
